<lib-date-range-field
  [ngModel]="rango()"
  [startLabelKey]="rotuloInicio()"
  [endLabelKey]="rotuloFin()"
  [referenceDate]="systemDate()"
  [minDate]="minDate() ?? null"
  [maxDate]="maxDate() ?? null"
  [errorMsg]="errorVigencia()"
  (ngModelChange)="alElegirRango($event)"
/>
